import React, { Component } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
/* Redux imports */
import { connect } from "react-redux";
import { searchActions, searchSelectors } from "../../store/search";
import SearchForm from "../../components/Forms/SearchInput";
import { Backdrop, Block, Button as ButtonKit, Divider, Overlay, Portal, Step } from "reakit";
import { Box, Card, Flex, Heading, Text } from "rebass";
import { Switch } from "@smooth-ui/core-sc";
import IosArrowForward from "react-ionicons/lib/IosArrowForward";
import UserList from "../../components/UserList";
// import {FloatingButton} from "../../components/Base/Buttons";
import { filterListWithSearch } from "../../utils";
import PositionBox from "../../components/Base/PositionBox";
import Audience from "./Audience";
import { colors } from "../../theme";
import IosArrowBack from "react-ionicons/lib/IosArrowBack";

const FilterOverlay = styled(Overlay)`
  width: 100%;
  height: 100%;
`;

const Arrow = styled(IosArrowForward)`
  //margin-top: 10px;
`;
const HeaderWrapper = styled(Card)`
  position: relative;
  top: 0;
  left: 0;
  width: 100vw;
  padding-bottom: 18px;
  max-height: 137px;
`;

const StyledFloatingButton = styled(ButtonKit)`
  z-index: 99999999;
  height: 50px;
  width: 50px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);

  svg {
    color: white;
  }
`;

const FloatingButton = ({ children, color, bottom = "80px", ...rest }) => (
  <PositionBox
    position={["fixed"]}
    zIndex={"99999"}
    right={"22px"}
    top={window.matchMedia("(display-mode: standalone)").matches && '80vh'}
    bottom={!window.matchMedia("(display-mode: standalone)").matches && '4vh'}
  >
    <StyledFloatingButton
      {...rest}
      color={color}
      m={1}
      borderRadius="50px"
      alignItems={"center"}
      justifyContent={"center"}
      textAlign={"center"}
    >
      {children}
    </StyledFloatingButton>
  </PositionBox>
);

class Customize extends Component {
  state = {
    pinned: false,
    isImportant: false,
    audience: {},
    selected: []
  };

  componentDidMount() {
    if (this.props.editPost) {
      this.setState({ pinned: this.props.isPinned, isImportant: this.props.isImportant });
    }
  }

  handleSelect = e => {
    const { handlePinned } = this.props;

    if (e.target.name === "is_pinned") {
      this.setState({ pinned: e.target.checked });
    }
    if (e.target.name === "is_important") {
      this.setState({ isImportant: e.target.checked });
    }
    // this.setState({[e.target.name]: e.target.checked});
    handlePinned(e.target.name, e.target.checked);
  };

  handleFacultySelect = details => {
    const { handlePinned } = this.props;

    let { selected } = this.state;
    console.log("selected for roster", details);
    let contains = false;
    for (var i = selected.length - 1; i >= 0; i--) {
      if (selected[i] === details.id) {
        selected.splice(i, 1);
        contains = true;
        this.setState({ selected });
        // break;       //<-- Uncomment  if only the first term has to be removed
      }
    }

    if (!contains) {
      selected.push(details.id);
      this.setState({ selected });
    }

    handlePinned("faculty", selected);
  };

  submitHandler = callback => {
    callback();
    this.props.handleSubmit();
  };

  render() {
    const { selected, pinned, isImportant } = this.state;
    const {
      search,
      editPost,
      editAudience,
      isFaculty,
      locations,
      handleAudience,
      ready,
      school,
      faculty,
      notFloating,
      radioAudience,
      handleRadioChange,
      handleAudienceFaculty,
      audienceFaculty,
      handleSelectGeneral,
      generalStudent,
      generalFaculty
    } = this.props;
    let facultyList = faculty;
    if (search !== null && faculty.length > 0) {
      facultyList = filterListWithSearch(faculty, search);
    }
    return (
      <Overlay.Container>
        {overlay => (
          <Flex>
            {notFloating ? (
              <Flex {...overlay} onClick={overlay.show} width={1}>
                <Box>
                  <Text color="#969a9b" fontSize={"15px"} fontWeight={600}>
                    Customize
                  </Text>
                </Box>
                <Box>
                  <Arrow color={"#969a9b"} onClick={overlay.show} fontSize={"17px"} />
                </Box>
              </Flex>
            ) : (
              <FloatingButton
                backgroundColor={ready ? colors.purple : colors.meta}
                use={Overlay.Show}
                {...overlay}
                disabled={!ready}
              >
                <IosArrowForward size={"30px"} color={"white"} />
              </FloatingButton>
            )}
            <Backdrop use={[Portal, Overlay.Hide]} {...overlay} />
            <FilterOverlay use={Portal} {...overlay} margin={0} padding={0}>
              <Box>
                <Step.Container initialState={{ current: 0 }} margin={0} padding={0}>
                  {step => (
                    <Box>
                      <HeaderWrapper boxShadow={"main"} p={2}>
                        <Box ml={0} mt={2} height={"30px"} width={"30px"}>
                          <IosArrowBack
                            fontSize={"30px"}
                            onClick={step.current > 0 ? step.previous : overlay.hide}
                          />
                        </Box>
                        <Heading ml={"8px"}>{step.current === 1 ? "Invite Faculty" : "Customize"}</Heading>
                      </HeaderWrapper>
                      <Block fontWeight={600}>
                        <Step step="Step 1" {...step}>
                          <Block>
                            {isFaculty ? (
                              <Flex flexDirection={"column"}>
                                <Box>
                                  <Text p={2} ml={1}>
                                    Pin
                                  </Text>
                                </Box>
                                <Box ml={"auto"} mr={2}>
                                  <Switch
                                    name={"is_pinned"}
                                    checked={pinned}
                                    onChange={this.handleSelect}
                                  />
                                </Box>
                                <Box>
                                  <Text p={2} ml={1}>Important</Text>
                                </Box>
                                <Box ml={"auto"} mr={2}>
                                  <Switch
                                    name={"is_important"}
                                    checked={isImportant}
                                    onChange={this.handleSelect}
                                  />
                                </Box>
                                <Divider />
                              </Flex>
                            ) : (
                              <Box py={2} />
                            )}
                            <Audience
                              dorms={school.dorms}
                              locations={locations}
                              handleUpdate={handleAudience}
                              editPost={editPost}
                              defaultValue={editAudience}
                              isFaculty={isFaculty}
                              radioAudience={radioAudience}
                              handleRadioChange={handleRadioChange}
                              audienceFaculty={audienceFaculty}
                              handleAudienceFaculty={handleAudienceFaculty}
                              handleSelectGeneral={handleSelectGeneral}
                              generalStudent={generalStudent}
                              generalFaculty={generalFaculty}
                            />
                          </Block>
                        </Step>
                        <Step step="Step 2" {...step}>
                          <SearchForm placeholders={"Search Faculty"}/>
                          <UserList
                            students={facultyList}
                            selected={selected}
                            handleUserClick={this.handleFacultySelect}
                          />
                        </Step>
                      </Block>
                      <FloatingButton
                        bottom={"22px"}
                        backgroundColor={step.current === 1 ? (selected.length > 0 ? colors.purple : colors.meta) : colors.purple}
                        onClick={isFaculty || step.current === 1 ? () => this.submitHandler(overlay.hide) : step.next}
                        {...step}
                        disabled={step.current === 1 ? (selected > 0 ? false : true) : false}
                      >
                        <IosArrowForward size={"30px"} color={"white"} />
                      </FloatingButton>
                    </Box>
                  )}
                </Step.Container>
              </Box>
            </FilterOverlay>
          </Flex>
        )}
      </Overlay.Container>
    );
  }
}

Customize.propTypes = {
  notFloating: PropTypes.bool,
  editPost: PropTypes.bool
};

Customize.defaultProps = {
  notFloating: false,
  editPost: false
};

const mapStateToProps = state => ({
  search: searchSelectors.refreshSearch(state.search)
});

const mapDispatchToProps = dispatch => ({
  updateSearch: term => {
    dispatch(searchActions.updateSearch(term));
  },
  clearSearch: () => {
    dispatch(searchActions.clearSearch());
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Customize);
